"use client"

import { ArrowDown10 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ArrowDown10Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ArrowDown10Icon = component(Icon)({ as: ArrowDown10 })
